import React, { useState, useContext } from 'react';
import {DatePicker} from 'antd';
import {dateToString, stringToDate} from '../utils/dateUtils';
import { api, apiAbs } from '../api/index';
import {getApplication} from '../api/applicationAPI';
import { FormContext } from './metadata/MDForm';
import { ModelContext } from './metadata/ModelSource';
import { ApplicationActionsContext } from './data/ApplicationDataSource';
import {ProductInfoContext} from './data/ApplicationDataSource';
import {navigate} from "../navigation/navigationHistory";

export function CoverageStartDate({ attr, value, onChange, ...props }) {
  const [errors, setError] = useState({
    showError: false,
    errorMessage: null
  });
  const [dataPickerOpenStatus, setDataPickerOpenStatus] = useState(false);
  const actions = useContext(ApplicationActionsContext);
  const productInfoContext = useContext(ProductInfoContext);

  const { setValueByAttr } = useContext(FormContext);
  const applicationModel = useContext(ModelContext);

  const { systemId } = applicationModel.data;


  //keeps track of the previous coverage start date, if no coverage start date is entered previousValidStartDate is set to the current effectiveDate
  const [previousValidStartDate, setPreviousValidStartDate] = useState(applicationModel.data.basicPolicy.effectiveDt)

  const handleChange = async (newDate) => {
    setError({showError: false});

    if(newDate === null){
      setValueByAttr(attr, undefined);
      //  onChange(undefined);
     return;
    }
    if (dateToString(newDate) !== previousValidStartDate) {
      if(value === undefined){
        /*needed to handle this edge case:
          The user clears the start date fills some more data on the field and then selects a
          new start date.  Set the effectiveDate back to the last valid effective date in order to
          be able to save the application to the backend
        */
        setValueByAttr(attr, previousValidStartDate);
        //  onChange(previousValidStartDate);

      }
        await actions.saveApplication();
        await api.post('/applications/' + systemId + '/changeTermDatesRequest', {
          effectiveDt: dateToString(newDate),
          ignoreWarnings: true,
          automaticallyChangeProductVersion: true
        }).then( ()=>{
          actions.resetProductSetup();
          actions.pullApplication();
          setPreviousValidStartDate( dateToString(newDate));

        }).catch(err => {
          if (err.response && (err.response.status === 503)) {
            navigate('/server-maintenance');
          }
          const message = err.response.data&&err.response.data.message;
          setError({showError: true, errorMessage: message});
          setValueByAttr(attr, previousValidStartDate);
        //  onChange(previousValidStartDate);
        })
    }
  };

  return (
      <React.Fragment>
        <div>
          <DatePicker
              aria-label='Coverage Start Date'
              aria-expanded={dataPickerOpenStatus}
              onOpenChange={(status)=>setDataPickerOpenStatus(status)}
              format={[
                'MM/DD/YYYY',
                'MMDDYYYY',
                'MM-DD-YYYY',
                'MM/D/YYYY',
                'MM-D-YYYY',
                'M-D-YYYY',
              ]}
              value={value ? stringToDate(value) : null}
              onChange={handleChange}
          />
          <div style={{ flexDirection: 'column' }}>
            {errors.showError && (
                <span role={"alert"} className='fieldError'>{errors.errorMessage}</span>
            )}
          </div>
        </div>
      </React.Fragment>
  );
}
